// extracted by mini-css-extract-plugin
module.exports = {"VideoAvatarContainer":"VideoAvatar_VideoAvatarContainer__Qntdp","AvatarStoryButtonSmall":"VideoAvatar_AvatarStoryButtonSmall__SU_eE"};